/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Compare_Leveling_CoreInputs */



/**
* | output |
* | --- |
* | "XP, levels and perk roles" |
*
* @param {Pricing_Compare_Leveling_CoreInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const pricing_compare_leveling_core = /** @type {((inputs?: Pricing_Compare_Leveling_CoreInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Compare_Leveling_CoreInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("XP, уровни и роли-привилегии")
	return /** @type {LocalizedString} */ ("XP, levels and perk roles")
});